import { Component, signal } from '@angular/core';
import { InspectionDashboardFilter } from '@pages/inspection-dashboard-page/inspection-dashboard-filter/inspection-dashboard-filter.component';
import { InspectionDashboardMode } from '@pages/inspection-dashboard-page/inspection-dashboard-mode';

@Component({
  standalone: false,
  selector: 'wr-inspection-dashboard-page',
  templateUrl: './inspection-dashboard-page.component.html',
  styleUrls: ['./inspection-dashboard-page.component.scss'],
})
export class InspectionDashboardPageComponent {
  readonly filter = signal<InspectionDashboardFilter>({ assignedToCurrentUser: true, hideNeverInspected: true });
  readonly mode = signal<InspectionDashboardMode>('overdue');
}
